export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-info-c21c814a58b1d882101300ddd8e8693d.svg";